<a
    class="relative w-8 h-8 rounded-lg overflow-hidden"
    routerLink="/profile"
    routerLinkActive
    #link="routerLinkActive"
    pTooltip="My Profile"
    tooltipPosition="right">
    <img
        [src]="userAvatar"
        (error)="onProfileImageFailedToLoad()"
        alt="Profile Picture"
        class="w-full h-full rounded-lg object-cover border-2 border-transparent hover:border-blurple"
        [ngClass]="{ '!border-[3px] !border-blurple-dark': link.isActive }" />
</a>
